import axiosClient from "./axios-client";
import {formatDataToUrlQueryParams} from "../utils/generalUtils";

export const getJobs = async (filterData) => {
  const queryParams = formatDataToUrlQueryParams(filterData);
  const response = await axiosClient.get(`/jobs?${queryParams}`);

  return response.data;
};

export const createJob = async (type) => {
  const response = await axiosClient.post("/jobs", {
    type,
  });

  return response.data;
};

export const getJob = async (id) => {
  const response = await axiosClient.get(`/jobs/${id}`);

  return response.data;
};

export const deleteJob = async (jobId) => {
  const response = await axiosClient.delete(`/jobs/${jobId}`);

  return response.data;
};

export const runParseJob = async (jobId, fileId) => {
    const response = await axiosClient.post(
        "/jobs/parse",
        {
            job_id: jobId,
            file_id: fileId,
        }
    );

    return response.data;
};

export const runSplitJob = async (jobId, fileId) => {
    const response = await axiosClient.post(
        "/jobs/split",
        {
            job_id: jobId,
            file_id: fileId,
        }
    );

    return response.data;
};

export const runTranscribeJob = async (jobId, fileId) => {
    const response = await axiosClient.post(
        "/jobs/transcribe",
        {
            job_id: jobId,
            file_id: fileId,
        }
    );

    return response.data;
};

export const getJobResult = async (jobId) => {
    const response = await axiosClient.get(
        `/jobs/${jobId}/result`
    );

    return response.data;
};